import React from 'react'
import { makeStyles } from '@mui/styles'
import { ErrorMessage } from 'formik'

export const CustomErrorMessage: React.FC<{
  name: string
  component: string | React.ComponentType<{}> | undefined
}> = ({ name }) => {
  const classes = useStyles()
  return (
    <ErrorMessage name={name}>
      {(msg) => <div className={classes.errorMessage}>{msg}</div>}
    </ErrorMessage>
  )
}

const useStyles = makeStyles({
  errorMessage: {
    color: 'red'
  }
})
